import {ActivePlatformAlertsSortField, type ClientPlatformAlert} from './typedef';


export const COLUMNS = {
    ALERT_MESSAGE: 'message',
    ALERT_TYPE: 'type',
    START_DATE: 'startDate',
    START_TIME: 'startTime',
    END_DATE: 'endDate',
    END_TIME: 'endTime',
};

export const HEADERS = {
    [COLUMNS.ALERT_MESSAGE]: 'Alert Message',
    [COLUMNS.ALERT_TYPE]: 'Alert Type',
    [COLUMNS.START_DATE]: 'Start Date',
    [COLUMNS.END_DATE]: 'End Date',
    [COLUMNS.START_TIME]: 'Start Time',
    [COLUMNS.END_TIME]: 'End Time',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.ALERT_MESSAGE,
        fixed: true,
        defaultWidth: 700,
        minWidth: 500,
        maxWidth: 800,
    },
    {
        columnId: COLUMNS.ALERT_TYPE,
        fixed: false,
        defaultWidth: 250,
        minWidth: 250,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.START_DATE,
        fixed: false,
        defaultWidth: 200,
        minWidth: 150,
        maxWidth: 250,
    },
    {
        columnId: COLUMNS.START_TIME,
        fixed: false,
        defaultWidth: 200,
        minWidth: 150,
        maxWidth: 250,
    },
    {
        columnId: COLUMNS.END_DATE,
        fixed: false,
        defaultWidth: 200,
        minWidth: 150,
        maxWidth: 250,
    },
    {
        columnId: COLUMNS.END_TIME,
        fixed: false,
        defaultWidth: 200,
        minWidth: 150,
        maxWidth: 250,
    },
];

export const PLACE = 'Platform Active Alerts';

export const SORT_MAP = {
    [ActivePlatformAlertsSortField.ALERT_MESSAGE]: (
        a: ClientPlatformAlert,
        b: ClientPlatformAlert,
        direction: 'ASC' | 'DESC',
    ) => {
        return direction === 'ASC'
            ? a.message.localeCompare(b.message)
            : b.message.localeCompare(a.message);
    },
    [ActivePlatformAlertsSortField.ALERT_TYPE]: (
        a: ClientPlatformAlert,
        b: ClientPlatformAlert,
        direction: 'ASC' | 'DESC',
    ) => {
        return direction === 'ASC'
            ? a.alertType.localeCompare(b.alertType)
            : b.alertType.localeCompare(a.alertType);
    },
    [ActivePlatformAlertsSortField.START_DATE]: (
        a: ClientPlatformAlert,
        b: ClientPlatformAlert,
        direction: 'ASC' | 'DESC',
    ) => {
        const dateA = new Date(a.startDate);
        const dateB = new Date(b.startDate);
        return direction === 'ASC'
            ? dateA.getTime() - dateB.getTime()
            : dateB.getTime() - dateA.getTime();
    },
    [ActivePlatformAlertsSortField.END_DATE]: (
        a: ClientPlatformAlert,
        b: ClientPlatformAlert,
        direction: 'ASC' | 'DESC',
    ) => {
        const dateA = new Date(a.endDate);
        const dateB = new Date(b.endDate);
        return direction === 'ASC'
            ? dateA.getTime() - dateB.getTime()
            : dateB.getTime() - dateA.getTime();
    },
    [ActivePlatformAlertsSortField.START_TIME]: (
        a: ClientPlatformAlert,
        b: ClientPlatformAlert,
        direction: 'ASC' | 'DESC',
    ) => {
        return direction === 'ASC'
            ? a.startTime.localeCompare(b.startTime)
            : b.startTime.localeCompare(a.startTime);
    },
    [ActivePlatformAlertsSortField.END_TIME]: (
        a: ClientPlatformAlert,
        b: ClientPlatformAlert,
        direction: 'ASC' | 'DESC',
    ) => {
        return direction === 'ASC'
            ? a.endTime.localeCompare(b.endTime)
            : b.endTime.localeCompare(a.endTime);
    },
};

export const SORT_FIELDS = {
    [COLUMNS.ALERT_MESSAGE]: ActivePlatformAlertsSortField.ALERT_MESSAGE,
    [COLUMNS.ALERT_TYPE]: ActivePlatformAlertsSortField.ALERT_TYPE,
    [COLUMNS.START_DATE]: ActivePlatformAlertsSortField.START_DATE,
    [COLUMNS.END_DATE]: ActivePlatformAlertsSortField.END_DATE,
    [COLUMNS.START_TIME]: ActivePlatformAlertsSortField.START_TIME,
    [COLUMNS.END_TIME]: ActivePlatformAlertsSortField.END_TIME,
};
